import { render } from "./AboutVersionSection.vue?vue&type=template&id=a6c064f2"
import script from "./AboutVersionSection.vue?vue&type=script&lang=js"
export * from "./AboutVersionSection.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__